
    const data = {"name":"src/core/icons/minus-box-outline","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M19 19V5H5v14h14m0-16a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-2 8v2H7v-2h10Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            